import { useFormContext } from "@saas-ui/forms";
import { SubmitButton as SaasUISubmitButton } from "@saas-ui/react";
import React from "react";

export const SubmitButton = ({
  children,
  isDisabled,
}: {
  children: React.ReactNode;
  isDisabled?: boolean;
}) => {
  const {
    formState: { isValid },
  } = useFormContext();
  return (
    <SaasUISubmitButton
      disabled={isDisabled || !isValid}
      data-cy="submit-button"
    >
      {children}
    </SaasUISubmitButton>
  );
};
